<style lang='less' scoped>
	@import '../base.less';
</style>
<template>
	<div>
		<!-- SEARCH -->
		<!--    -->
		<Row>
			<Col span='24'>
			<Card>
				<Form :model="windowAddItem" :label-width="400" label-position="left">
					<FormItem label='21:30~21:45自动采集开奖数据' prop='isAutoCaiji'>
						<i-switch v-model='windowAddItem.isAutoCaiji' @on-change="v=>{autoChange(v,'isAutoCaiji')}"
							:true-value="1" :false-value="0" true-color="#13ce66" />
					</FormItem>
					<FormItem label='每天22:30自动生成' prop='isAutoMake'>
						<i-switch v-model='windowAddItem.isAutoMake' @on-change="v=>{autoChange(v,'isAutoMake')}"
							:true-value="1" :false-value="0" true-color="#13ce66" />
					</FormItem>
					<FormItem label='自动换帖子' prop='isAutoChangeBbs'>
						<i-switch v-model='windowAddItem.isAutoChangeBbs'
							@on-change="v=>{autoChange(v,'isAutoChangeBbs')}" :true-value="1" :false-value="0"
							true-color="#13ce66" />
					</FormItem>
<!--          <FormItem label='生成页面是否需要加密' prop='isJiami'>-->
<!--            <i-switch v-model='windowAddItem.isJiami'-->
<!--                      @on-change="v=>{autoChange(v,'isJiami')}" :true-value="1" :false-value="0"-->
<!--                      true-color="#13ce66" />-->
<!--          </FormItem>-->

          <FormItem label='页面加密方式' style="width: 900px">
            <Select clearable v-model='windowAddItem.isJiami' style='width:200px'   @on-change="v=>{autoChange(v,'isJiami')}">
              <Option :value="0" >{{ $t('不加密') }}</Option>
              <Option :value="2" >{{ $t('JS型加密') }}</Option>
              <Option :value="1" >{{ $t('AES超级加密(打开较慢)') }}</Option>
            </Select>
          </FormItem>

					<FormItem label='连错多少次自动换帖' prop='bbsMaxErrorToChange'>
						<InputNumber :max="10" :min="1" :step="1" @on-change="v=>{autoChange(v,'bbsMaxErrorToChange')}"
							v-model="windowAddItem.bbsMaxErrorToChange" />
					</FormItem>
					<FormItem label='手动采集并更新数据' style="width: 900px">
						<Button type="info" :loading="isCaiji" @click="caiji"
							style="margin-right:10px">采集开奖并更新数据</Button>
					</FormItem>
					<FormItem label='页面生成' style="width: 900px">
						<Button type="primary" @click="make(0)" :loading="isMaking_0" style="margin-right:10px">新澳门</Button>
            <Button type="primary" @click="make(2)" :loading="isMaking_2" style="margin-right:10px">老澳门</Button>
            <Button type="primary" @click="make(1)" :loading="isMaking_1" style="margin-right:10px">香港</Button>
            <Button type="primary" @click="make(7)" :loading="isMaking_7" style="margin-right:10px">快乐8</Button>
            <Button type="primary" @click="make(4)" :loading="isMaking_4" style="margin-right:10px">柬埔寨</Button>
            <Button type="primary" @click="make(5)" :loading="isMaking_5" style="margin-right:10px">台湾</Button>
            <Button type="primary" @click="make(6)" :loading="isMaking_6" style="margin-right:10px">印尼</Button>
            <Button type="primary" @click="make(7)" :loading="isMaking_7" style="margin-right:10px">马来西亚</Button>
            <Button type="primary" @click="make(100)" :loading="isMaking_tuku" style="margin-right:10px">图库</Button>
            <Button type="primary" @click="make(200)" :loading="isMaking_qnzl" style="margin-right:10px">全年资料</Button>
            <Button type="primary" @click="make(300)"  style="margin-right:10px">一肖中特</Button>
					</FormItem>
					<FormItem label='查看站点' style="width: 900px">
						<Button type="error" @click="openTestUrl" style="margin-right:10px">查看站点</Button>
					</FormItem>
         <br>

          <div>----------------自动生成杀生肖区域-----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='香港杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_1' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='香港杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_1' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_1' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='香港杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_1' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='香港杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_1' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='香港杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_1' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>

          <div>---------------新澳门杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='澳门杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_0' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='新澳门杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_0' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_0' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='新澳门杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_0' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='新澳门杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_0' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='新澳门杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_0' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>

          <div>---------------老澳门杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_2' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_2' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_2' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_2' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_2' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_2' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>

          <div>---------------快乐8杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_3' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_3' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_3' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_3' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_3' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_3' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>

          <div>--------------柬埔寨杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_4' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_4' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_4' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_4' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_4' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_4' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>

          <div>--------------台湾杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_5' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_5' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_5' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_5' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_5' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_5' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>
          <div>--------------印尼杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_6' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_6' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_6' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_6' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_6' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_6' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>
          <div>--------------马来西亚杀肖区----------------------------------------------------------------------------------------------------</div>
          <br>
          <FormItem label='杀波色(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Select clearable v-model='windowAddItem.killBs_7' style='width:200px'>
              <Option :value="'无'" :key='无'>{{ $t('无') }}</Option>
              <Option :value="'红'" :key='红'>{{ $t('红') }}</Option>
              <Option :value="'绿'" :key='绿'>{{ $t('绿') }}</Option>
              <Option :value="'蓝'" :key='蓝'>{{ $t('蓝') }}</Option>
            </Select>
          </FormItem>


          <FormItem label='杀号码(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killNum_7' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='杀尾数(请在开奖前设置下一期要杀的内容,用.隔开)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killWs_7' :placeholder="$t(' 如:1.2.3') "></Input>
          </FormItem>

          <FormItem label='杀生肖(也可杀门\杀段\杀头等非纯数字玩法)(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killSx_7' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>

          <FormItem label='杀平特肖(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtSx_7' :placeholder="$t('如: 牛虎') "></Input>
          </FormItem>


          <FormItem label='杀平码(请在开奖前设置下一期要杀的内容)' style="width: 900px">
            <Input clearable v-model='windowAddItem.killPtNum_7' :placeholder="$t('如:1.2.3') "></Input>
          </FormItem>
          <FormItem label='保存杀肖内容' style="width: 900px">
            <Button type="primary" @click="saveKillData()"  style="margin-right:10px">保存杀肖内容</Button>
          </FormItem>
				</Form>

			</Card>
			</Col>
		</Row>


	</div>
</template>
<script>
	import internationality from '@/components/internationality'
	import {
		urlGet,
		urlEdit,
		customPost
	} from '@/api/Lhc/Lhc'
	import {
		formattingMonth,
		lastMonthDate
	} from '@/libs/time'
	import {
		baseUrl
	} from '@/libs/api.request'
	import {
		getToken
	} from '@/libs/util'

	export default {
		name: 'interface_list',
		data() {
			return {
				uploadUrlCk: baseUrl + 'Index/uploadCk',
				uploadUrl: baseUrl + 'Index/upload',
				uploadHeader: {
					'Authorization': "bearer " + getToken()
				},
				timeOptions: {
					shortcuts: [{
							text: '今天',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
									1000 - 1)
								return [a, b]
							}
						},
						{
							text: '昨天',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000)
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000 + 24 * 60 *
									60 * 1000 - 1)
								return [a, b]
							}
						},
						{
							text: '一周',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000 * 7)
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
									1000 - 1)
								return [a, b]
							}
						},
						{
							text: '本月',
							value() {
								return formattingMonth()
							}
						},
						{
							text: '上月',
							value() {
								return lastMonthDate()
							}
						},
					]
				},
				columnsList: [],
				tableData: [], //用于放LIST数据绑定
				tableShow: { //用于分页
					currentPage: 1,
					pageSize: 10,
					listCount: 0
				},
				searchConf: {
					searchTime: [],
				}, // 搜索字段
				extraParams: [],
				buttonShow: { //按钮状态显示
					edit: true,
					del: true,
					changeStatus: true
				},
				listLoading: false, //显示加载中状态
				//弹窗--------------
				windowAdd: { //弹窗
					show: false,
					loading: false,
					index: 0
				},
				windowAddItem: { //弹窗数据绑定
					id: 0,
					logo: ''
				},
				windowAddValidate: { //窗口校验规则
				},
				isCaiji: false,
				isMaking_0: false,
        isMaking_1: false,
        isMaking_2: false,
        isMaking_7: false,
        isMaking_4: false,
        isMaking_5: false,
        isMaking_6: false,
        isMaking_7: false,
        isMaking_tuku: false,
        isMaking_qnzl: false,
				isAutoChangeBbs: false,
        isJiami:false
			}
		},
		components: {
			internationality
		},
		created() {
			let vm = this
			vm.getList()
			vm.hasRule('systemManage/siteSetting/edit').then(res => {
				vm.buttonShow.edit = res
			})
			vm.hasRule('systemManage/siteSetting/del').then(res => {
				vm.buttonShow.del = res
			})
			vm.hasRule('systemManage/siteSetting/changeStatus').then(res => {
				vm.buttonShow.changeStatus = res
			})
		},
		mounted() {
			this.getParams()
		},
		methods: {
			preAdd() {
				let vm = this
				vm.windowAdd.show = true
			},
			getParams() {
				// getParams().then(response => {
				//     this.extraParams = response.data.data
				// })
			},
			changePage(page) {
				this.tableShow.currentPage = page
				this.getList()
			},
			changeSize(size) {
				this.tableShow.pageSize = size
				this.getList()
			},
			search() {
				this.tableShow.currentPage = 1
				this.getList()
			},
			getList() {
				let vm = this
				vm.listLoading = true
				urlGet({
					page: 1,
				}).then(response => {
					vm.windowAddItem = response.data.data
				})
			},

			timeChange(datetimerange) { //时间修改，自动计算尾部时间
				if (datetimerange[0] !== '' && datetimerange[1] !== '') {
					let patt = /00:00:00/
					this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
					if (patt.test(datetimerange[1])) {
						datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
						this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
					}
				} else {
					this.searchConf.searchTime = []
				}
			},
			sortChange: function({
				column,
				key,
				order
			}) {
				//order值可能为asc,desc,normal
				this.searchConf.order = [key, order]
				if (order == 'normal') {
					this.searchConf.order = []
				}
				this.getList()
			},
			windowAddCancel(data) {
				if (!data) {
					this.windowAddItem.id = 0
					this.$refs['windowAddForm'].resetFields()
					this.windowAdd.show = false
					this.windowAdd.loading = false
					this.windowAdd.index = 0
				}
			},
			windowAddSubmit() {
				let vm = this
				vm.windowAdd.loading = true
				urlEdit(vm.windowAddItem).then(response => {
					vm.$Message.success(response.data.msg)
					vm.getList()
					vm.windowAddCancel()
				}).catch(() => {
					vm.windowAdd.loading = false
				})

			},
      saveKillData(){
        customPost('Lhc/urlEdit', {
          killWs_0: this.windowAddItem.killWs_0,
          killWs_1: this.windowAddItem.killWs_1,
          killWs_2: this.windowAddItem.killWs_2,
          killWs_3: this.windowAddItem.killWs_3,
          killWs_4: this.windowAddItem.killWs_4,
          killWs_5: this.windowAddItem.killWs_5,
          killWs_6: this.windowAddItem.killWs_6,
          killWs_7: this.windowAddItem.killWs_7,


          killSx_0: this.windowAddItem.killSx_0,
          killBs_0: this.windowAddItem.killBs_0,
          killNum_0: this.windowAddItem.killNum_0,
          killPtSx_0: this.windowAddItem.killPtSx_0,
          killPtNum_0: this.windowAddItem.killPtNum_0,

          killSx_1: this.windowAddItem.killSx_1,
          killBs_1: this.windowAddItem.killBs_1,
          killNum_1: this.windowAddItem.killNum_1,
          killPtSx_1: this.windowAddItem.killPtSx_1,
          killPtNum_1: this.windowAddItem.killPtNum_1,
          killSx_2: this.windowAddItem.killSx_2,
          killBs_2: this.windowAddItem.killBs_2,
          killNum_2: this.windowAddItem.killNum_2,
          killPtSx_2: this.windowAddItem.killPtSx_2,
          killPtNum_2: this.windowAddItem.killPtNum_2,

          killSx_3: this.windowAddItem.killSx_3,
          killBs_3: this.windowAddItem.killBs_3,
          killNum_3: this.windowAddItem.killNum_3,
          killPtSx_3: this.windowAddItem.killPtSx_3,
          killPtNum_3: this.windowAddItem.killPtNum_3,

          killSx_4: this.windowAddItem.killSx_4,
          killBs_4: this.windowAddItem.killBs_4,
          killNum_4: this.windowAddItem.killNum_4,
          killPtSx_4: this.windowAddItem.killPtSx_4,
          killPtNum_4: this.windowAddItem.killPtNum_4,

          killSx_5: this.windowAddItem.killSx_5,
          killBs_5: this.windowAddItem.killBs_5,
          killNum_5: this.windowAddItem.killNum_5,
          killPtSx_5: this.windowAddItem.killPtSx_5,
          killPtNum_5: this.windowAddItem.killPtNum_5,

          killSx_6: this.windowAddItem.killSx_6,
          killBs_6: this.windowAddItem.killBs_6,
          killNum_6: this.windowAddItem.killNum_6,
          killPtSx_6: this.windowAddItem.killPtSx_6,
          killPtNum_6: this.windowAddItem.killPtNum_6,

          killSx_7: this.windowAddItem.killSx_7,
          killBs_7: this.windowAddItem.killBs_7,
          killNum_7: this.windowAddItem.killNum_7,
          killPtSx_7: this.windowAddItem.killPtSx_7,
          killPtNum_7: this.windowAddItem.killPtNum_7,

        }).then(response => {
          this.getList();
          this.$Message.success(response.data.msg)
        })
      },
			openTestUrl() {
				let vm = this
				window.open(vm.windowAddItem.testUrl, '_blank')
			},
			caiji() {
				this.isCaiji = true;
				customPost('Lhc/caiji', {}).then(response => {
					this.isCaiji = false;
					this.$Message.success(response.data.msg)
				})
				params.loading = false
			},

			make(type) {
        this.setMaking(type,true)
				customPost('Lhc/make', {type:type}).then(response => {
          this.setMaking(type,false)
					this.$Message.success(response.data.msg)
				})
			},

      setMaking(type,isTrue){
        if(type==0){
            this.isMaking_0=isTrue
        }else if(type==1){
          this.isMaking_1=isTrue
        }else if(type==2){
          this.isMaking_2=isTrue
        }else if(type==7){
          this.isMaking_7=isTrue
        }else if(type==4){
          this.isMaking_4=isTrue
        }else if(type==5){
          this.isMaking_5=isTrue
        }else if(type==6){
          this.isMaking_6=isTrue
        }else if(type==7){
          this.isMaking_7=isTrue
        }else if(type==100){
          this.isMaking_tuku=isTrue
        }else if(type==200){
          this.isMaking_qnzl=isTrue
        }
      },

			autoChange(trueOrFalse, buttonKey) {
				if (buttonKey == 'bbsMaxErrorToChange') {
					customPost('Lhc/urlEdit', {
						bbsMaxErrorToChange: trueOrFalse
					}).then(response => {
						this.getList();
						this.$Message.success(response.data.msg)
					})
				} else if (buttonKey == 'isAutoCaiji') {
					customPost('Lhc/urlEdit', {
						isAutoCaiji: trueOrFalse ? 1 : 0
					}).then(response => {
						this.getList();
						this.$Message.success(response.data.msg)
					})

				} else if (buttonKey == 'isAutoChangeBbs') {
					customPost('Lhc/urlEdit', {
						isAutoChangeBbs: trueOrFalse ? 1 : 0
					}).then(response => {
						this.getList();
						this.$Message.success(response.data.msg)
					})
				} else if (buttonKey == 'isJiami') {
          customPost('Lhc/urlEdit', {
            isJiami: trueOrFalse
          }).then(response => {
            this.getList();
            this.$Message.success(response.data.msg)
          })
        }else {
					customPost('Lhc/urlEdit', {
						isAutoMake: trueOrFalse ? 1 : 0
					}).then(response => {
						this.getList();
						this.$Message.success(response.data.msg)
					})
				}
			}

		}
	}
</script>
